import { AppShell } from '@mantine/core';
import { createExportReportAccountsButton } from 'features/export-report-accounts';
import { createAccountReportRegistry } from 'entities/account';
import { accountsReportPageModel } from '../../model';
import cls from './accounts-report-page.module.scss';

export const AccountReportRegistry = createAccountReportRegistry(
	accountsReportPageModel.accountReportRegistryModel,
);

export const ExportReportAccountsButton = createExportReportAccountsButton(
	accountsReportPageModel.exportReportAccountsModel,
);

export const AccountsReportPage = () => (
	<AppShell.Main className={cls.accountsReportPage}>
		<AccountReportRegistry topBarActionSlot={<ExportReportAccountsButton />} />
	</AppShell.Main>
);
